import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { OrganizationGuard } from './core/guards/organization.guard';

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    loadChildren: () => import('./modules/dashboard/dashboard.module').then( m => m.DashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: "users",
    loadComponent: () => import('./core/auth/pages/users/users.component').then( c => c.UsersComponent),
    canActivate: [AuthGuard],
  },
  {
    path: ":organizationName/flows",
    loadChildren: () => import('./modules/flows/flows.module').then( m => m.FlowsModule),
    canActivate: [AuthGuard, OrganizationGuard],
  },
  {
    path: ':organizationName/connectors',
    loadChildren: () => import('./modules/connectors/connectors.module').then( m => m.ConnectorsModule), 
    canActivate: [AuthGuard, OrganizationGuard],
  },
  {
    path: 'dictionary',
    loadChildren: () => import('./modules/dictionary/dictionary.module').then( m => m.DictionaryModule), 
    canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./core/auth/auth.module').then( m => m.AuthModule)
  },
  {
    path: "not-found",
    loadComponent: () => import('./share/components/not-found/not-found.component').then( m => m.NotFoundComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'queries',
    loadChildren: () => import('./modules/queries/queries.module').then( m => m.QueriesModule), 
    canActivate: [AuthGuard]
  },
  {
    path: 'forms',
    loadChildren: () => import('./modules/dynamics-forms/dynamics-forms.module').then( m => m.DynamicsFormsModule),
    canActivate: [AuthGuard],
  },
  {
    path: ":organizationName",
    loadComponent: () => import('./modules/flows/pages/flows-dashboard/flows-dashboard.component').then( c => c.FlowsDashboardComponent),
    canActivate: [AuthGuard, OrganizationGuard],
  },
  {
    path:"**",
    redirectTo: "not-found",
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, 
      { 
      useHash: true,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      enableTracing: false,
      paramsInheritanceStrategy: 'always', })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
